import Swiper, { Mousewheel } from 'swiper';
import 'swiper/css';

const selectors = {
  carouselWrapper: '[data-tab-carousel]',
};

class BlogTemplate extends HTMLElement {
  constructor() {
    super();

    document.addEventListener('DOMContentLoaded', () => {
      this.breakpoint = window.matchMedia('(max-width:639px)');

      // Init the carousel on load.
      this.initCarousels();

      // Subsequently, on resize, we need to check if we need a Swiper object checking the break point.
      // If not, it will get destroyed.
      this.registerEventListeners();
    });
  }

  initCarousels() {
    if (this.carousel) {
      // Clean up the swiper object for re-initialisation.
      this.carousel.destroy();
    }

    if (this.breakpoint.matches) {
      this.carousel = new Swiper(selectors.carouselWrapper, {
        freeMode: true,
        slidesPerView: 'auto',
        watchOverflow: true,
      });
    } else {
      this.carousel = new Swiper(selectors.carouselWrapper, {
        modules: [Mousewheel],
        freeMode: true,
        slidesPerView: 'auto',
        watchOverflow: true,
        mousewheel: {
          forceToAxis: true,
          sensitivity: 100,
        },
      });
    }
  }

  registerEventListeners() {
    window.addEventListener('resize', () => {
      this.initCarousels();
    });
  }
}

customElements.define('blog-template', BlogTemplate);
